module.exports = __webpack_public_path__ + "static/media/userIcon.c739f391.svg";